import React from 'react';

const DashPlaceholder: React.FC = () => <span className="h-[1px] w-[10px] bg-gray-darkest" />;

export default DashPlaceholder;
